import { Action } from 'store/store';
import { AppSettingsState } from './AppSettingsState';
import State from 'store/State';
import { selectAppSettings } from './selectors';
import { AnyAction } from 'redux';

export enum AppSettingsActionType {
    UPDATE = 'APP_SETTINGS_UPDATE',
    LOAD = 'APP_SETTINGS_LOAD',
}

export type UpdateAppSettingsAction = Action<
    AppSettingsActionType.UPDATE,
    Partial<AppSettingsState>
>;

export const updateAppSettings: (
    delta: Partial<AppSettingsState>
) => UpdateAppSettingsAction = (delta) => ({
    type: AppSettingsActionType.UPDATE,
    payload: delta,
});

export function isUpdateAppSettingsAction(
    action: AnyAction
): action is UpdateAppSettingsAction {
    return action.type === AppSettingsActionType.UPDATE;
}

export type LoadAppSettingsAction = Action<
    AppSettingsActionType.LOAD,
    Partial<AppSettingsState>
>;

export const loadAppSettings: (
    delta: Partial<AppSettingsState>
) => LoadAppSettingsAction = (delta) => ({
    type: AppSettingsActionType.LOAD,
    payload: delta,
});

export type AppSettingsAction = UpdateAppSettingsAction | LoadAppSettingsAction;

export function isAppSettingsSymbologyChange(
    prevState: State,
    nextState: State
): boolean {
    const prev = selectAppSettings(prevState).symbology;
    const next = selectAppSettings(nextState).symbology;
    return prev !== next;
}
